import { IconButton } from '@eventbrite/marmalade';
import React from 'react';
import {
    DEFAULT_STYLES,
    getStyles,
    REBRANDING_STYLES,
} from '../../../utils/rebrand';
import { InfoSvg } from '../assests/InfoSvg';
import defaultStyles from '../EventInfoCard.module.scss';
import rebrandStyles from '../EventInfoCard.rebrand.module.scss';

const stylesModules = {
    [DEFAULT_STYLES]: defaultStyles,
    [REBRANDING_STYLES]: rebrandStyles,
};

interface EventPriceProps {
    isAppRebrandActive: boolean;
    ticketPrice?: string;
    onPaneToggle?: () => void;
}

const EventPrice: React.FC<EventPriceProps> = ({
    isAppRebrandActive = false,
    ticketPrice,
    onPaneToggle,
}) => {
    const theme = getStyles(isAppRebrandActive);
    const styles = stylesModules[theme];
    return (
        <>
            {ticketPrice ? (
                <div
                    className={styles.costAndInfoIconWrapper}
                    data-testid="event-price"
                >
                    <p className={styles.ticketPrice}>{ticketPrice}</p>
                    {onPaneToggle && (
                        <IconButton
                            aria-label="Info"
                            icon={<InfoSvg />}
                            onClick={onPaneToggle}
                        />
                    )}
                </div>
            ) : null}
        </>
    );
};

export default EventPrice;
